import { apiRequest, ResultAPI } from 'app/requests/apiRequest';
import env from '.env.json';

interface Cache {
  key: string;
  value: any;
  ttl?: number;
}

export const getCache = async (key: string) => {
  try {
    const result = await apiRequest(`/api/cache/${key}`, 'get', {}, false, env.URL_API_NODE) as string;
    return result;
  } catch (error) {
    console.error(error)
    return '';
  }
};

export const setCache = async (params: Cache) => {
  try {
    await apiRequest('/api/cache', 'post', params, false, env.URL_API_NODE) as ResultAPI;
  } catch (error) {
    console.error(error)
  }
};

export const deleteCache = async (key: string) => {
  await apiRequest(`/api/cache/${key}`, 'delete', {}, false, env.URL_API_NODE) as ResultAPI;
};

export const clearAllCache = async () => {
  await apiRequest('/api/cache', 'delete', {}, false, env.URL_API_NODE) as ResultAPI;
};
